<template>
  <nav class="BlogYearSelector t-mono-xs">

    <div class="BlogYearSelector-arrow"
      :class="{ 'BlogYearSelector-arrow--isSelectable': showPreviousArrow }"
      @click="previous">
      <
    </div>

    <div class="BlogYearSelector-slider"
      ref="slider">

      <router-link class="BlogYearSelector-item"
        ref="item"
        v-for="year in years"
        :key="year.year"
        :to="year.route">

        {{ year.year }}

      </router-link>

    </div>

    <div class="BlogYearSelector-arrow"
      :class="{ 'BlogYearSelector-arrow--isSelectable': showNextArrow }"
      @click="next">
      >
    </div>

  </nav>
</template>

<script>
import Flickity from 'flickity'

export default {
  name: 'BlogYearSelector',

  props: {
    years: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      showNextArrow: false,
      showPreviousArrow: false
    }
  },

  watch: {
    years () {
      this.$nextTick(this.init)
    }
  },

  mounted () {
    if (!this.years.length) return
    this.$nextTick(this.init)
  },

  destroyed () {
    this.removeEventListeners()
  },

  methods: {
    /**
     * Initialize
     */
    init () {
      this.flickity = new Flickity(this.$refs.slider, {
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true
      })

      this.flickity.on('select', this.showHideArrows)
      this.flickity.on('staticClick', this.handleFlickityStaticClick)

      // Select cell of current year
      this.selectCellForCurrentYear()

      this.showHideArrows()
    },

    removeEventListeners () {
      if (!this.flickity) return
      this.flickity.off('select', this.showHideArrows)
      this.flickity.off('staticClick', this.handleFlickityStaticClick)
    },

    /**
     * Select the cell for the current year
     */
    selectCellForCurrentYear () {
      const routeYear = this.$route.hash.replace('#', '')

      if (!routeYear) return

      this.years.forEach((year, index) => {
        if (year === routeYear) this.flickity.select(index, false, true)
      })
    },

    /**
     * Go to previous item
     */
    previous () {
      this.flickity.previous()
    },

    /**
     * Go to next item
     */
    next () {
      this.flickity.next()
    },

    /**
     * Show or hide previous/next arrows depending on selected cell
     */
    showHideArrows () {
      this.showPreviousArrow = this.flickity.selectedIndex > 0
      this.showNextArrow = this.flickity.selectedIndex < this.flickity.cells.length - 4
    },

    /**
     * Handle staticClick event
     * @param  {Object} event
     * @param  {Object} pointer
     * @param  {Object} cellElement
     * @param  {Integer} cellIndex
     */
    handleFlickityStaticClick (event, pointer, cellElement, cellIndex) {
      if (!cellElement) return
      this.flickity.select(cellIndex)
    }
  }
}
</script>

<style>
@import 'properties';
@import 'flickity/dist/flickity.css';

.BlogYearSelector {
  display: flex;
}

.BlogYearSelector-slider {
  position: relative;
  z-index: 0;
  width: 208px;
}

.BlogYearSelector-slider::before,
.BlogYearSelector-slider::after {
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  bottom: 0;
  width: 12px;
  display: block;
  content: '';
  pointer-events: none;
}

.BlogYearSelector-slider::before {
  left: 0;
  background-image: linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0));
}

.BlogYearSelector-slider::after {
  right: 0;
  background-image: linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0));
}

.BlogYearSelector-item {
  display: inline-block;
  width: 52px;
  text-align: center;
}

.BlogYearSelector-item.router-link-active {
  color: inherit;
}

.BlogYearSelector-arrow {
  position: relative;
  z-index: 1;
  cursor: pointer;
  user-select: none;
  transition: color 0.3s ease, opacity 0.3s ease;
  color: inherit;
  opacity: 0.25;
}

.BlogYearSelector-arrow--isSelectable {
  color: var(--c-blue);
  opacity: 1;
}

.BlogYearSelector-arrow::after {
  position: absolute;
  top: -5px;
  right: -5px;
  bottom: -5px;
  left: -5px;
  display: block;
  content: '';
}

.BlogYearSelector-arrow--enter-active,
.BlogYearSelector-arrow--leave-active {
  transition: opacity 0.3s ease;
}

.BlogYearSelector-arrow--enter,
.BlogYearSelector-arrow--leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// BlogYearSelector.vue?4bebe648